import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectEvchargeEnergyAggregation = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.EvchargeEnergyAggregationComponent
);

export const selectEvchargeEnergyAggregationMonthlyData = (instanceId: string, systemId: string) =>
  createSelector(
    selectEvchargeEnergyAggregation,
    (evchargeEnergyAggregationComponent) =>
      evchargeEnergyAggregationComponent[instanceId]?.[systemId]?.monthlyData
  );

export const selectEvchargeEnergyAggregationYearlyData = (instanceId: string, systemId: string) =>
  createSelector(
    selectEvchargeEnergyAggregation,
    (evchargeEnergyAggregationComponent) =>
      evchargeEnergyAggregationComponent[instanceId]?.[systemId]?.yearlyData
  );

export const selectEvchargeEnergyAggregationMonthlyState = (instanceId: string, systemId: string) =>
  createSelector(
    selectEvchargeEnergyAggregation,
    (evchargeEnergyAggregationComponent) =>
      evchargeEnergyAggregationComponent[instanceId]?.[systemId]?.monthlyState || 'pending'
  );

export const selectEvchargeEnergyAggregationYearlyState = (instanceId: string, systemId: string) =>
  createSelector(
    selectEvchargeEnergyAggregation,
    (evchargeEnergyAggregationComponent) =>
      evchargeEnergyAggregationComponent[instanceId]?.[systemId]?.yearlyState || 'pending'
  );

export const selectEvchargeEnergyAggregationError = (instanceId: string, systemId: string) =>
  createSelector(
    selectEvchargeEnergyAggregation,
    (evchargeEnergyAggregationComponent) =>
      evchargeEnergyAggregationComponent[instanceId]?.[systemId]?.error
  );
